/* ==========================================================================
   Elevate Floors — Página de serviço, Seção 07: depoimentos

   O ponto técnico: os slides são position:absolute empilhados (é o que
   permite o cross-fade), e elementos absolutos saem do fluxo — o container
   colapsaria para altura zero sem altura explícita.

   A saída ingênua é cravar a altura do maior depoimento; aí o card fica desse
   tamanho o tempo todo e sobra vazio nos curtos. Aqui a altura do slide ATIVO
   é medida e escrita, com transição: o card encolhe e cresce junto com o fade.

   Remedir em quatro momentos, todos necessários: troca de slide, resize,
   depois que as fontes carregam (a métrica da DM Sans altera a altura) e na
   primeira renderização.
   ========================================================================== */
(function () {
  'use strict';

  // um listener global de resize, não um por instância: o editor de tema
  // troca o nó da section a cada save e o nó novo não carrega a flag
  function onResize(fn, root) {
    if (!window._efRevResize) {
      window._efRevResize = [];
      window.addEventListener('resize', function () {
        window._efRevResize.forEach(function (f) { try { f(); } catch (e) {} });
      });
    }
    window._efRevResize = window._efRevResize.filter(function (f) {
      return f._root && f._root.isConnected;
    });
    fn._root = root;
    window._efRevResize.push(fn);
  }

  function initSection(section) {
    if (section._efSrevBound) return;
    section._efSrevBound = true;

    var stage = section.querySelector('[data-stage]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('.ef-srev__dot'));
    if (!stage || !slides.length) return;

    var i = 0, timer = null, lastH = 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var INTERVAL = (parseFloat(section.dataset.interval) || 0) * 1000;
    if (reduce) INTERVAL = 0;

    function measure() {
      var el = slides[i];
      if (!el) return;
      var h = Math.ceil(el.getBoundingClientRect().height);
      // tolerância de 1px: sem ela, o arredondamento fracionário faria a
      // altura ser reescrita em loop
      if (h && Math.abs(lastH - h) > 1) {
        stage.style.height = h + 'px';
        lastH = h;
      }
    }

    function paint() {
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      measure();
    }

    function show(n) {
      i = (n + slides.length) % slides.length;
      paint();
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      // o listener de visibilitychange fica em document e sobrevive ao nó: sem
      // esta guarda, cada save no editor deixa mais um intervalo rodando sobre
      // uma section que ja saiu do DOM
      if (!section.isConnected) return;
      if (INTERVAL > 0 && slides.length > 1) {
        timer = setInterval(function () { show(i + 1); }, INTERVAL);
      }
    }
    // qualquer clique reinicia o relógio: sem isso a troca automática dispara
    // um segundo depois da ação manual e parece bug
    function go(n) { show(n); start(); }

    section.querySelectorAll('.ef-srev__arrow').forEach(function (b) {
      b.addEventListener('click', function () { go(i + parseInt(b.dataset.dir, 10)); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.go, 10)); });
    });

    // Pausar no hover so onde existe hover. No celular o toque dispara um
    // mouseenter emulado e o mouseleave correspondente muitas vezes NUNCA
    // vem: a troca automatica parava no primeiro toque e nao voltava mais.
    if (window.matchMedia('(hover: hover)').matches) {
      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
    }
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });
    onResize(measure, section);

    paint();
    // a métrica da fonte muda a altura medida
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure);
    } else {
      setTimeout(measure, 400);
    }
    start();
  }

  function init() {
    document.querySelectorAll('[data-srev]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
